import { FC, MouseEvent, useState } from 'react';
import { Buttons, Form, FormElements, H1 } from '../../../common/AddEditFormLayout/AddEditFormLayout.styles';
import Header from '../../../common/Header/Header';
import Button from '../../../components/Button/Button';
import Dropdown from '../../../components/Dropdown/Dropdown';
import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import { RadioGroupLayouts } from '../../../components/RadioGroup/RadioGroup.types';
import { DropdownWrapper } from '../../StoreControl/StoreRecord.styles';
import { ManInvRawProdFormProps, ManInvRawProdValues } from './ManInvRawProdForm.types';
import { ManInvConcept, ManInvConceptKeys } from '../../../constants/ManInv';
import { ManInvFrequency } from '../../../constants/ManInv';
const ManInvRawProdForm: FC<ManInvRawProdFormProps> = ({
  handleSelect,
  rawProdOptions,
  formValues,
  onFrequencyChange,
  onSave,
  isSaveLoading,
  saveButtonDisabled,
}) => {

  const [formErrors, setFormErrors] = useState<ManInvRawProdValues>({
    frequencyNo: '',
    conceptNo: '',
    manInvRawProdId: '',
  });

  const handleSave = (event: MouseEvent) => {
    event.preventDefault();
    let error = false;
    let newFormErrors = {
     frequencyNo: '',
     conceptNo: '',
     manInvRawProdId: '',
    };

    setFormErrors(newFormErrors);
    if (error) {
      return;
    }
    if (onSave) onSave();
  };

  return (
    <>
      <Header breadcrumb={{ label: 'Back to Table', to: '/tables/mandatoryinventory/' }} />
      <Form>
        <FormElements>
          <H1>Add New ManINV Item</H1>
          {/* add the dropdown menu  */}

          <DropdownWrapper>
            <Dropdown 
            label='Raw Product' 
            id='manInvRawProdId'
            options={[...rawProdOptions]}
            onChange={handleSelect}
            errorText={formErrors?.manInvRawProdId}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Dropdown 
            label='Concept' 
            id='conceptNo'
            options={Object.keys(ManInvConcept).map((key: any) => {
              return { value: key, label: `${key} - ${ManInvConcept[key as ManInvConceptKeys]}` };
            })}
            onChange={handleSelect}
            errorText={formErrors?.conceptNo}
            />
          </DropdownWrapper>
          <RadioGroup
            id='frequencyNo'
            label='Frequency'
            selected={formValues?.frequencyNo}
            errorText={formErrors?.frequencyNo}
            onChange={onFrequencyChange}
            layout={RadioGroupLayouts.Row}
            options={[
              {
                id: Object.keys(ManInvFrequency)[1],
                label: ManInvFrequency[2],
              },
              { id: Object.keys(ManInvFrequency)[0], 
                label: ManInvFrequency[1] },
            ]}
          />
        </FormElements>
        <Buttons>
          <Button label='Add' onClick={handleSave} isLoading={isSaveLoading} disabled={saveButtonDisabled} />
        </Buttons>
      </Form>
    </>
  );
};

export default ManInvRawProdForm;
